import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { misc } from './components/shared/misc.js';
import { fields } from './components/shared/fields.js';
import { routing } from './components/shared/routing.js';
import { session } from './components/shared/session.js';
import { api } from './components/shared/api.js';
import { transaction } from './components/shared/transaction.js';
import { action } from './components/shared/action.js';
import { files } from './components/shared/files.js';
import { text } from './components/shared/text.js';
import { dialog } from './components/shared/dialogs.js';
import { appearance } from './components/shared/appearance.js';
import { catalogs } from './components/shared/catalogs.js';
import { dictionaries } from './components/shared/dictionaries.js';
import { alerts } from './components/shared/alerts.js';
//mport { global } from './components/shared/global.js';

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);


Vue.config.productionTip = false;

Vue.mixin({
  mixins: [fields, routing, session, api, misc, transaction, action, files, text, dialog, appearance, catalogs, dictionaries, alerts],
  methods: {
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
